import { Link } from "@/i18n/navigation";
import { getAirlineLogoUrl } from "@/utils/airlineLogoHelper";
import Image from "next/image";

export default function ItemCard({
  title,
  image,
  onClick,
  className = "",
  IataCode,
  airlineUrl,
}) {
  // Logo URL'ini belirle: önce IataCode'dan, sonra image prop'undan, en son fallback
  const logoUrl =
    (IataCode && getAirlineLogoUrl(IataCode)) ||
    image ||
    "/images/dummy/thy.jpg";

  return (
    <Link
      className={`group border-border-card flex cursor-pointer items-center justify-start gap-3 overflow-hidden rounded-lg border bg-white p-4 ${className}`}
      onClick={onClick}
      href={airlineUrl}
      title={title}
    >
      <div className="relative h-[42px] w-[42px] flex-shrink-0 overflow-hidden rounded">
        <Image
          src={logoUrl}
          alt={title}
          fill
          className="object-cover"
          sizes="100%"
        />
      </div>
      <div className="flex flex-col items-start justify-center gap-2">
        <h3 className=" text-foreground text-lg/26 font-medium">
          {title}
        </h3>
        <p className="text-foreground text-sm/19 font-normal">
          IATA Kodu : {IataCode}
        </p>
      </div>
    </Link>
  );
}
